import React from 'react';
import Cube from './Cube';
import Logo from './../images/francis_logo.js';

class About extends React.Component {
	rotateCube( cubeID, xDegrees, yDegrees ) {
		var cube = document.getElementById(cubeID);
		cube.style.transform = 'rotateX(' + xDegrees + 'deg) rotateY(' + yDegrees + 'deg)';
	}
	render () {
		return (
			<section id="about" name="about" className="section u-pt">
				<div className="container">
					<div className="row">
						<div className="sm-12 col u-mb+">
			  				<h2 className="heading--primary u-mb">About</h2>
			  				<p>Ah, about me, where do I start? I love climbing mountains, cats and dogs (why choose?) and using code to create fun and interactive user experiences! I'm a web dev where my skills are best used when working on a JavaScript app, refactoring that spaghetti code into easy to maintain components or, helping out on a Ruby on Rails or WordPress project. Currently, I'm available for remote contract work. <a href="mailto:francislanglois.com" className="link">Contact me for more info!</a></p>
						</div>
						<div className="sm-12 col">
							<div className="u-mb+">
								<Cube
									id="cube--about"
									front={
										<Logo className="u-center--absolute" />
									}
									top="My work etiquette comes from my passion to help others. Whether I'm squashing a bug or, adding a new feature I find value in how code is making somebody's life easier."
									left="I strive to find simplicity in my code and UX solutions. I work dilligently to find the solution where every stakeholder feels nothing but ease of use when handling my work."
									right="Code can be aesthetically pleasing to work with. I like to add beauty to websites via simple animations all while pushing the boundaries of what a browser can do for a user."
								/>
							</div>
							<div className="u-text--center">
								<button className="button heartbeat u-mr- u-mb+" onClick={() => {this.rotateCube('cube--about', 0, 90 );}}>Simplicity</button>
								<button className="button heartbeat u-mr- u-mb+" onClick={() => {this.rotateCube( 'cube--about', -90, 0 );}}>Professionalism</button>
								<button className="button heartbeat u-mr- u-mb+" onClick={() => {this.rotateCube( 'cube--about', 0, -90 );}}>Elegance</button>
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js